import React from "react";
import type {VoidFunctionComponent} from "react";
import {appPagePaths} from "../../../config/config";
import {Navigate, useMatch } from "react-router-dom";
import {SongsResultsHome} from "../results-songs-home/SongsResultsHome";
import {SongsResultsBrowse} from "../results-songs-browse/SongsResultsBrowse";
import {SongsResultsLibrary} from "../results-songs-library/SongsResultsLibrary";

export const SongsResultsRouter: VoidFunctionComponent = () => {
  const isSongRoot = !!useMatch('/songs');
  const isHomePage = !!useMatch('/songs/home');
  const isBrowsePage = !!useMatch('/songs/browse');
  const isLibraryPageAllTab = !!useMatch('/songs/library');
  const isLibraryPageFavoritesTab = !!useMatch('/songs/library/favorites');
  const isLibraryPage = isLibraryPageAllTab || isLibraryPageFavoritesTab;

  if (isHomePage || isSongRoot) {
    return <SongsResultsHome />;
  }

  if (isBrowsePage) {
    return <SongsResultsBrowse />;
  }

  if (isLibraryPage) {
    return <SongsResultsLibrary />;
  }

  return <Navigate to={appPagePaths.dashboardPage} />;
}
